import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import NumberFormat from "react-number-format";
import Table from "../../../../components/common/table/Table";
import { formatDateSmallWithoutTimezone } from "../../../../utils/dates";
import { Mixpanel } from "../../../../actions/mixpanel.actions";
import { INVOICE_INDEX_TABLE } from "../../../../actions/invoice.actions";

import styles from "./Invoice.scss";

class Invoice extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const invoices = _.get(this.props, "invoices");

    const mappedInvoices =
      invoices.length > 0 &&
      invoices.map(invoice => {
        const project = _.get(invoice, "project");
        const status = _.get(invoice, "status");
        const user = _.get(invoice, "user");

        return {
          rowKey: invoice.id,
          data: [
            {
              displayText: this.getDate(invoice),
              orderByText: invoice.created_at
            },
            {
              displayText: this.getProjectDisplayText(project),
              orderByText: project.title
            },
            {
              displayText: this.getMemberDisplayText(user),
              orderByText: user.full_name
            },
            {
              displayText: this.getStatusDisplayText(status, invoice),
              orderByText: status.id
            },
            {
              displayText: this.getAmountDisplayText(invoice.amount),
              orderByText: invoice.amount
            }
          ]
        };
      });

    return this.renderInvoices(mappedInvoices);
  }

  getDate(invoice) {
    return (
      <div className={styles.rowHeaderSubtitle}>
        {formatDateSmallWithoutTimezone(invoice.created_at)}
      </div>
    );
  }

  getAmountDisplayText(amount) {
    return (
      <NumberFormat
        value={amount}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
        decimalScale={2}
      />
    );
  }

  getStatusDisplayText(status, invoice) {
    let text = status.employer;
    text = text.replace("{amount}", _.get(invoice, "amount"));

    if (_.get(invoice, "quickbooks_id")) {
      text = `${text} - Quickbooks ID ${invoice.quickbooks_id}`;
    }

    return text;
  }

  getProjectDisplayText(project) {
    return (
      <div>
        <Link
          to={`/company/project/${project.id}`}
          onClick={() =>
            Mixpanel.track("Employer - Invoices - Project Job Title")
          }
        >
          {project.title}
        </Link>
      </div>
    );
  }

  getMemberDisplayText(user) {
    let name = _.get(user, "full_name");

    if (this.isUserAdmin(user)) {
      name = "The Second Shift";
    }
    return name;
  }

  isUserAdmin(user) {
    return (
      _.size(
        _.filter(user.roles, {
          name: "admin"
        })
      ) > 0
    );
  }

  renderInvoices(mappedInvoices) {
    const tableData = {
      headers: [
        {
          displayText: "DATE",
          id: "table-employer-invoices-sort-date",
          track: "Table - Employer Invoices - Sort By Date"
        },
        {
          displayText: "PROJECT",
          id: "table-employer-invoices-sort-project",
          track: "Table - Employer Invoices - Sort By Project"
        },
        {
          displayText: "USER",
          id: "table-employer-invoices-sort-user",
          track: "Table - Employer Invoices - Sort By User"
        },
        {
          displayText: "STATUS",
          id: "table-employer-invoices-sort-status",
          track: "Table - Employer Invoices - Sort By Status"
        },
        {
          displayText: "AMOUNT",
          id: "table-employer-invoices-sort-amount",
          track: "Table - Employer Invoices - Sort By Amount"
        }
      ],
      rows: mappedInvoices
    };

    const defaultSort = {
      headerIndex: 0,
      order: "desc"
    };

    return (
      <div className={styles.invoices}>
        <h2 className={styles.pageTitle}>Invoices</h2>
        <p className={styles.pageSubTitle}>
          Track the invoices submitted by your hired employers here. We will
          send your invoices directly to your billing manager as specified in
          your <Link to="/company/payment/information">account settings.</Link>
        </p>
        <p className={styles.pageSubTitle}>
          Questions about payments?{" "}
          <a href="https://thesecondshift.com/contact-us" target="_blank">
            Contact us
          </a>
        </p>

        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name={INVOICE_INDEX_TABLE}
          defaultSort={defaultSort}
          tableData={tableData}
        />
      </div>
    );
  }
}

export default Invoice;



// WEBPACK FOOTER //
// ./src/routes/employer/invoice/components/Invoice.js